/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import BackButton from "../../../components/BackButton";
import Layout from "../../../layout";
import { useLocation } from "react-router-dom";
import LeaderList from "./LeaderList";
import Points from "./Points";
import FeedTabs from "./FeedTabs";
import { useTourGuide } from "../../../hooks/useTourGuide";

import "./feeds.css";

const League = () => {
  useTourGuide();
  const { pathname } = useLocation();
  const [showScrollButton, setShowScrollButton] = useState(false);
  const feedScrollRef = useRef(null);

  // Scroll detection on the feed container (not window) so the right
  // sidebar stays independent of the feed scroll.
  useEffect(() => {
    const container = document.querySelector(".feed-tab-content");
    if (!container) return;

    const handleScroll = () => {
      setShowScrollButton(container.scrollTop > 300);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  const handleScrollToTop = () => {
    const container = document.querySelector(".feed-tab-content");
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const displayData = () => {
    if (pathname.includes("list")) {
      return <LeaderList />;
    } else if (pathname.includes("point")) {
      return <Points />;
    } else {
      return <FeedTabs />;
    }
  };

  return (
    <Layout>
      <BackButton />

      <div className="mx-4x pb-4z">{displayData()}</div>

      {/* Scroll to Top Button */}
      {showScrollButton && (
        <button
          onClick={handleScrollToTop}
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#3A6ED4",
            color: "white",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
            zIndex: 1000,
            transition: "all 0.3s ease",
          }}
          className="scroll-to-top-button"
          aria-label="Scroll to top"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 15l-6-6-6 6" />
          </svg>
        </button>
      )}
    </Layout>
  );
};

export default League;
